import React from "react";
import ReactDOM from "react-dom";
import LeadsTipy from "./screens/LeadsTipy";
import "./index.css";
import * as serviceWorker from "./serviceWorker";

ReactDOM.render(<LeadsTipy />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about serv    ice workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
